import { render, staticRenderFns } from "./CompanyprofileLeft.vue?vue&type=template&id=2f32ee2a&scoped=true&"
import script from "./CompanyprofileLeft.vue?vue&type=script&lang=js&"
export * from "./CompanyprofileLeft.vue?vue&type=script&lang=js&"
import style0 from "./CompanyprofileLeft.vue?vue&type=style&index=0&id=2f32ee2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f32ee2a",
  null
  
)

export default component.exports